export default "__VITE_ASSET__BxTL$jS___"